<template>
  <PageMain class="index-page">
    <!-- <Tips class="mt-20" /> -->
    <div v-if="msgs&&msgs.messages.length>0" class="flex mt-10">
      <div>收到{{ msgs.msgCount }} 条消息:</div>
      <MsgLooper :list="msgs.messages" />
    </div>
    <div class="flex">
      <div class="w-900">
        <div class="  mt-20">
          <div class="flex a-center ">
            <div class="fs-24  f-c-b1">上午好，{{ $store.state.user.userName }}</div> <div class="ml-20"><a-button @click="viz = true">一分钟了解</a-button><a-button class="ml-10" type="primary" @click="$router.push('/main/send')">我要寄件</a-button></div>
          </div>

          <div class="bg-w pd-20 mt-20">
            <div>
              <span class="fs-20 fs-b">寄件统计</span>
              <span class="ml-10">近一周</span>
            </div>
            <div class="flex a-center  flex-j-sb mt-20">
              <div class="flex it-border a-center flex-j-sb w-220  pl-20 border-c1">
                <div class="pointer" @click="$router.push('/main/search')">
                  <div class="fs-32 fs-b f-c-blue fslh-32">{{ info.unPickupCount }}</div>
                  <div class="f-c-b4 fs-14 fslh-32 ">待取件（单）</div>
                </div>
              </div>
              <div class="flex it-border a-center flex-j-sb w-220   pl-40 border-c2">
                <div class="pointer" @click="$router.push('/main/search?tab=2&m=6')">
                  <div class="fs-32 fs-b f-c-blue fslh-32">{{ info.pickupOvertimeCount }}</div>
                  <div class="f-c-b4 fs-14 fslh-32">揽件超时（单）</div>
                </div>
              </div>
              <div class="flex it-border a-center flex-j-sb w-220   pl-40 border-c3">
                <div class="pointer" @click="$router.push('/main/search?tab=2&s=0')">
                  <div class="fs-32 fs-b f-c-blue fslh-32">{{ info.noTrackCount }}</div>
                  <div class="f-c-b4 fs-14 fslh-32">发货无轨迹（单）</div>
                </div>
              </div>
              <div class="flex it-border a-center flex-j-sb w-220   pl-40 border-c4">
                <div class="pointer" @click="$router.push('/main/search?tab=2&s=3')">
                  <div class="fs-32 fs-b f-c-blue fslh-32">{{ info.signCount }}</div>
                  <div class="f-c-b4 fs-14 fslh-32">已签收（单）</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-20    ">
          <div class=" bg-w pd-20" style="">
            <div class="flex a-center flex-j-sb mb-20"><a-badge :count="notReadCount"><span class="fs-20 fs-b f-c-b1">订单实时状态&nbsp;&nbsp;&nbsp;</span></a-badge><span class="f-c-blue fs-b pointer" @click="$router.push('/main/search')">查看更多<a-icon type="right" /></span></div>
            <div style="height:400px;overflow:auto">
              <div v-for="(i,index) in statusList" :key="index" :class="i.isRead?'f-c-b3':'f-c-b2'" class="flex a-center pointer flex-j-sb mt-10" @click="toPage(i)">
                <div class="h-21 flex a-center">
                  <span class="  w-80 text-over inline-block">{{ i.orderStateName }}</span>
                  <span class="  w-160 ml-40 inline-block">{{ i.orderStateTimeDesc }}</span>
                  <span class="  w-120 ml-40 text-over inline-block" :title=" i.fromCity +'-'+ i.fromName ">{{ i.fromCity }}-{{ i.fromName }}</span>
                </div>
                <div class="w-470  flex1 ml-40" :title="i.content">
                  <span class="  w-80 t-right">{{ i.content }}</span>
                </div>
              </div>
              <div v-if="!statusList.length" class="mt-10">
                <a-empty />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="ml-20 w-280">
        <div class="flex a-center h-36 mt-20">
          <a-input v-model="code" class="mr-10 w-240" placeholder="请输入快递单号，例如:123456" @keyup.enter="$router.push('/main/trace?code='+code)" /> <a-button @click="$router.push('/main/trace?code='+code)">快速查件</a-button>
        </div>
        <div class="mt-20 bg-w pd-20">
          <div>
            <span class="fs-20 fs-b">企业信息</span>
          </div>
          <div class="mt-10 mb-16">{{ companyInfo.companyName || '--' }} <!-- <span v-if="!companyInfo.isIdentity">(未实名)</span> --></div>
          <div v-if="$store.state.user.isAdmin" class="mt-8">公司成员：{{ companyInfo.staffCount||0 }}人</div>
          <div v-if="!$store.state.user.isAdmin" class="mt-8">所在部门：{{ companyInfo.departmentname||'--' }}</div>
          <div class="mt-8">公司部门：{{ companyInfo.departmentCount||0 }} 个</div>
          <div class="mt-8">常用快递：{{ companyInfo.expressCount }}家<span v-if="$store.state.user.isAdmin" class="f-c-blue pointer ml-10" @click="$router.push('/main/manager/settlement-settings')">设置</span></div>
        </div>
        <div class="mt-20 bg-w pd-20">
          <div>
            <span class="fs-20 fs-b">热门问题</span>
          </div>
          <div class="mt-20 pointer" @click="hviz = true">快递公司运费标准</div>
          <div class="mt-8 pointer" @click="hviz = true">快递员未能及时上门取件？</div>
          <div class="mt-8 pointer" @click="hviz = true">能否寄个人的包裹快递？</div>
          <div class="mt-8 pointer" @click="hviz = true">下单后的取件码是什么？</div>
          <div class="mt-8 pointer" @click="hviz = true">包裹破损/丢件如何快速处理？</div>

        </div>
      </div>
    </div>
    <Tips :viz.sync="viz" />
    <HelperTips :viz.sync="hviz" />
    <PostAddrInfo :viz.sync="showInfoDialog" />
    <CouponTips :viz.sync="showCouponTips" />
    <select-company :show.sync="showSelect" />
  </PageMain>
</template>

<script>
import moment from 'moment'
import Tips from '@/components/tips'
import MsgLooper from '@/components/msgLooper'

import HelperTips from '@/components/helperTips'
import CouponTips from '@/components/couponTips'

import PostAddrInfo from '@/components/postAddrInfo'

import selectCompany from '@/components/selectCompany.vue'
export default {
  name: 'Dashboard',
  components: {
    Tips,
    PostAddrInfo,
    HelperTips,
    MsgLooper,
    CouponTips,
    selectCompany
  },
  data() {
    return {
      showSelect: false,
      showCouponTips: false,
      code: '',
      // dateRange: [moment().subtract(30, 'days').startOf('day').format(), moment().format()],
      viz: false,
      hviz: false,
      showInfoDialog: false,
      dateRange: [moment().startOf('month').startOf('day'), moment()],
      noRead: false,
      msgs: null,
      orderState: {
        '100': '待接单',
        '102': '已接单',
        '203': '已取消',
        '301': '已揽件',
        '3': '已签收'
        // O103("103", "已分配"),
        // O109("109", "转单"),
        // O101("101", "分配失败"),
        // O205("205", "无法联系上客户"),
        // O202("202", "已转单"),
        // O201("201", "已更改取件时间"),
        // O204("204", "延时取件"),
        // O302("302", "换单"),
        // O1("1","已揽件"),
        // O2("2","在途中"),
        // O4("4","问题件");
      },
      companyInfo: {
        companyAddress: '',
        companyArea: '',
        companyCity: '',
        companyLogo: '',
        companyName: '',
        companyPicture: '',
        companyProvince: '',
        contactEmail: '',
        contactMobile: '',
        contactName: '',
        contactQQ: '',
        contactWX: '',
        createTime: '',
        departmentCount: 0,
        expressCount: 0,
        id: '',
        industry: 0,
        isIdentity: 0,
        staffCount: 0,
        staffRange: 0,
        status: 0,
        userId: ''
      },
      statusList: [],
      OrderMonthStatistics: [],
      chartData: {
        columns: ['日期', '寄件总数'],
        rows: [
        ]
      },
      notReadCount: 0,
      info: {
        'dispatchCount': 0,
        'noTrackCount': 0,
        'pickupCount': 0,
        'pickupOvertimeCount': 0,
        'signCount': 0,
        'unPickupCount': 0
      }
    }
  },
  async created() {
    //
    if (this.$getToken()) {
      const res = await this.$http(this.$api.orderOrderAmountLastWeek)
      Object.assign(this.info, res)

      const orderGetStatusList = await this.$http(this.$api.orderGetNewestStatusList, {
        'customerId': this.$store.state.user.userId,
        'limitCount': 14
      })
      this.statusList = orderGetStatusList.orders || []
      this.notReadCount = orderGetStatusList.notReadCount
      this.search()
      await this.getInfo()
      this.getMsg()
      // this.showCoupon()
      // const orderOrderMonthStatistics = await this.$http(this.$api.orderGetStatusList, {
      //   'beginDate': '2020-05-23T08:04:23.142Z',
      //   'endDate': '2020-05-25T08:04:23.142Z'
      // })

      // console.log(orderOrderMonthStatistics)
    }
  },
  methods: {
    async showCoupon() {
      const res = await this.$http(this.$api.xzlmSendCoupon)
      const tips = sessionStorage.getItem('showCouponTips')
      if (res && this.companyInfo.id && !tips) {
        this.showCouponTips = true
        sessionStorage.setItem('showCouponTips', 1)
      }
    },
    async toPage(i) {
      // '100': '待接单',
      //   '102': '已接单',
      //   '203': '已取消',
      //   '301': '已揽件',
      //   '3': '已签收'
      if (!i.isRead) {
        await this.$http(this.$api.orderReadOrderMsg, {
          'id': i.id
        })
      }
      if (+i.orderState === 100 || +i.orderState === 102) {
        this.$router.push('/main/search')
      } else {
        this.$router.push('/main/search?tab=2')
      }
    },
    async getMsg() {
      const res = await this.$http(this.$api.messageGetMessageList)
      res.messages = res.messages || []
      if (res.messages.length === 1) {
        res.messages = res.messages.concat(res.messages)
      }
      this.msgs = res
    },
    async getInfo() {
      // TODO: 等后台修改
      const res = await this.$http(this.$api.enterpriseGetInfo)
      Object.assign(this.companyInfo, res)
      if (!this.companyInfo.id && this.$store.state.user.isAdmin) {
        this.showInfoDialog = true
      }
    },
    async search() {
      // this.dateRange[0]
      // console.log(this.dateRange)
      let orderMonthStatistics
      try {
        orderMonthStatistics = await this.$http(this.$api.orderOrderMonthStatistics, {
          'beginDate': this.dateRange[0].format('YYYY-MM-DD'),
          'endDate': this.dateRange[1].format('YYYY-MM-DD')
        })
        this.chartData.rows = orderMonthStatistics.reverse().map(el => {
          return { '日期': el.createDate, '寄件总数': el.totalCount }
        })
      } catch (error) {
        console.log(error)
      }

      // orderMonthStatistics = [{
      //   createDate: '2020-05-23',
      //   totalCount: '2'
      // }, {
      //   createDate: '2020-05-24',
      //   totalCount: '3'
      // }, {
      //   createDate: '2020-05-25',
      //   totalCount: '4'
      // }, {
      //   createDate: '2020-05-26',
      //   totalCount: '5'
      // }, {
      //   createDate: '2020-05-27',
      //   totalCount: '6'
      // }, {
      //   createDate: '2020-05-28',
      //   totalCount: '7'
      // }]
    }
  }
}
</script>
<style lang="scss" scoped>
.index-page{
  .msg-warp{
    height: 20px;
    overflow: hidden;
  }
  .it-border{
    // border-radius: 2px;;
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    &:last-child{
      border-right:none
    }
  }
  // .border-c1{
  //   border-top: 2px solid #a5d326 ;
  // }
  // .border-c2{
  //   border-top: 2px solid #61ca2a ;
  // }
  // .border-c3{
  //   border-top: 2px solid #2cc4c0 ;
  // }
  // .border-c4{
  //   border-top: 2px solid #2b9cff ;
  // }
}
</style>
